import { Injectable, Type } from "@angular/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";


@Injectable({
    "providedIn": "root"
})
export class ExcelService {
    private EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    private EXCEL_EXTENSION = ".xlsx";

    exportToExcel (workbook: XLSX.WorkBook, fileName: string): void {
        const excelBuffer: any = XLSX.write(workbook, { "bookType": "xlsx", "type": "array", "cellStyles": true });
        const data: Blob = new Blob([excelBuffer], { "type": this.EXCEL_TYPE });

        FileSaver.saveAs(data, fileName + this.EXCEL_EXTENSION);
    }

    getExcelBlob(workbook: XLSX.WorkBook, fileName: string): Blob {
        const excelBuffer: any = XLSX.write(workbook, { "bookType": "xlsx", "type": "array", "cellStyles": true });
        const data: Blob = new Blob([excelBuffer], { "type": this.EXCEL_TYPE });

        return data;
    }
}
